import { InfoOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

export default function Warnings({
  warnings,
  className,
}: {
  warnings?: string[];
  className?: string;
}) {
  if (!warnings?.length) {
    return null;
  }

  return (
    <Stack alignItems="center" className={cn('mt-16', className)} direction="col" gapY={8}>
      {warnings.map((warning) => (
        <Stack
          key={warning}
          alignItems="center"
          className="h-48 w-full rounded-8 bg-bg-secondary px-8"
          gapX={6}>
          <InfoOutline className="!h-16 !w-16" fillColorToken="icon-primary" />
          <Typography className="text-text-primary" numberOfLines={1} variant="body-short-02">
            {warning}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
